import { useToast } from 'vue-toastification';
import SucessToster from "~/components/toastify/sucess-toster.vue";
import ErrorToster from "~/components/toastify/error-toster.vue";
import WarningToster from "~/components/toastify/warning-toster.vue";

export const useGlobalToast = () => {
    const toast = useToast();

    const defaultToastOptions = {
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: false,
        draggable: false,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: 'button',
        icon: false,
        rtl: false
    };

    const showSuccess = (title: string, text: string, options?: any) => {
        toast.success({
            component: SucessToster,
            props: {
                title,
                text
            }
        }, {
            ...defaultToastOptions,
            ...options
        });
    };

    const showError = (title: string, text: string, options?: any) => {
        toast.error({
            component: ErrorToster,
            props: {
                title,
                text
            }
        }, {
            ...defaultToastOptions,
            ...options
        });
    };

    const showWarning = (title: string, text: string, options?: any) => {
        toast.warning({
            component: WarningToster,
            props: {
                title,
                text
            }
        }, {
            ...defaultToastOptions,
            ...options
        });
    };

    const showInfo = (title: string, text: string, options?: any) => {
        toast.info({
            component: WarningToster,
            props: {
                title,
                text
            }
        }, {
            ...defaultToastOptions,
            ...options
        });
    };

    return {
        showSuccess,
        showError,
        showWarning,
        showInfo
    };
};
